<template>
  <RouteView />
  <AppFeedback />
</template>

<script>
import AppFeedback from './components-new/common/AppFeedback.vue';
import { startAppUpdates } from './util/appUpdates';

export default {
  components: { AppFeedback },
  data() {
    return {};
  },

  async mounted() {
    window.$eventBus.$on("changeLang", this.syncLanguage);
    this.stopUpdates = await startAppUpdates();
  },
  beforeUnmount() {
    window.$eventBus.$off("changeLang", this.syncLanguage);
    if (this.stopUpdates) this.stopUpdates();
  },
  methods: {
    syncLanguage() {
      this.$i18n.locale = window.localStorage.getItem("LANG");
    }
  }
};
</script>
<style>
html {
  overflow-y: scroll;
}
body {
  background-color: #fafafa;
  min-height: 100vh;
}

@media screen and (max-width: 768px) {
  body {
    /* transform: scale(0.85); */
    /* transform-origin: top left; */
    width: 100%;
    /* padding: 5px; */
  }
  .el-card{
    overflow:auto;
  }

  /* el-pagination 移动端自动换行样式 */
  .el-pagination {
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 8px !important;
    padding: 10px 0 !important;
  }

  .el-pagination > * {
    flex-shrink: 0 !important;
  }

  /* 总数显示 */
  .el-pagination .el-pagination__total {
    order: 1;
    margin-right: 8px !important;
    font-size: 12px !important;
    white-space: nowrap;
  }

  /* 每页显示数量选择器 */
  .el-pagination .el-pagination__sizes {
    order: 2;
    margin-right: 8px !important;
  }

  .el-pagination .el-pagination__sizes .el-select {
    width: 90px !important;
  }

  .el-pagination .el-pagination__sizes .el-input__inner {
    font-size: 12px !important;
    padding: 0 20px 0 8px !important;
    height: 28px !important;
    line-height: 28px !important;
  }

  /* 页码导航 */
  .el-pagination .el-pager,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    order: 3;
    margin: 0 2px !important;
  }

  .el-pagination .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    min-width: 28px !important;
    height: 28px !important;
    line-height: 28px !important;
    font-size: 12px !important;
    padding: 0 4px !important;
  }

  /* 快速跳转 */
  .el-pagination .el-pagination__jump {
    order: 4;
    margin-left: 8px !important;
    font-size: 12px !important;
    white-space: nowrap;
  }

  .el-pagination .el-pagination__jump .el-pagination__editor {
    width: 40px !important;
    height: 28px !important;
    line-height: 28px !important;
    font-size: 12px !important;
    margin: 0 4px !important;
  }

  /* 当空间不足时，让某些元素换行 */
  .el-pagination .el-pagination__total,
  .el-pagination .el-pagination__sizes {
    flex-basis: auto;
    flex-grow: 0;
  }

  .el-pagination .el-pager,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    flex-basis: auto;
    flex-grow: 0;
  }

  /* 快速跳转：空间不足时自动换行 */
  .el-pagination .el-pagination__jump {
    flex-basis: auto;
    flex-grow: 0;
    min-width: 120px;
  }

  /* 当容器宽度不足时，快速跳转换到下一行 */
  @media screen and (max-width: 600px) {
    .el-pagination .el-pagination__jump {
      flex-basis: 100%;
      margin-top: 8px;
      margin-left: 0 !important;
    }
  }

  /* 超小屏幕优化 */
  @media screen and (max-width: 480px) {
    .el-pagination {
      gap: 6px !important;
    }

    .el-pagination .el-pagination__total {
      font-size: 11px !important;
      margin-right: 4px !important;
    }

    .el-pagination .el-pagination__sizes {
      margin-right: 4px !important;
    }

    .el-pagination .el-pagination__sizes .el-select {
      width: 75px !important;
    }

    .el-pagination .el-pager li,
    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      min-width: 26px !important;
      height: 26px !important;
      line-height: 26px !important;
      font-size: 11px !important;
      margin: 0 1px !important;
    }

    .el-pagination .el-pagination__jump {
      font-size: 11px !important;
    }

    .el-pagination .el-pagination__jump .el-pagination__editor {
      width: 35px !important;
      height: 26px !important;
      line-height: 26px !important;
      font-size: 11px !important;
    }
  }
}
</style>
